import { Form } from 'react-final-form';

import { CreateComplaintMutationFn } from '@containers/ComplaintModalContainer/queries/graphql.v3.generated';
import SuccessfulComplain from '@components/SuccessfulComplain';
import ComplaintHeader from '@components/ComplaintHeader';
import PickComplaint from '@components/PickComplaint';
import SubmitComplaint from '@components/SubmitComplaint';

// types
// TODO: Fix this the next time the file is edited.
 
type complaintType = {
  id: number,
  title: string,
};

interface Values {
  complaint?: string;
}

// TODO: Fix this the next time the file is edited.
 
type complaintFormType = {
  text: string,
  email: string,
};

// TODO: Fix this the next time the file is edited.
 
type increaseStepType = (counter: number) => void;

type ComplainFormProps = {
  types: complaintType[],
  refetch: (complaintId: { complaintId: number }) => void,
  step: number,
  increaseStep: increaseStepType,
  complaintId: number | null,
  setComplaintId: (complaintId: number) => void,
  userId: number,
  createComplaint: CreateComplaintMutationFn,
  closeModal: () => void
  closeSuccessModal: () => void,
  isMobile?: boolean,
  productId?: number,
  email: string | null | undefined
};

export const ComplainForm: React.FC<ComplainFormProps> = ({
  types,
  refetch,
  step,
  increaseStep,
  complaintId,
  setComplaintId,
  userId,
  createComplaint,
  closeModal,
  closeSuccessModal,
  isMobile,
  productId,
  email,
}) => {
  const submitComplaint = async (values: complaintFormType) => {
    let result;
    try {
      result = await createComplaint(
        {
          variables:
        {
          userId,
          productId,
          complaintText: values.text,
          complaintType: complaintId!,
          email: values.email,
        },
        },
      );
    } catch {
      result = {};
    }

    const data = result ? result.data ? result.data.createComplaint : null : null;
    if (data && data.isSuccess) {
      increaseStep(step + 1);
    } else {
      const errors = data ? data.errors : null;
      const field = errors ? errors[0].field : null;
      const error = errors ? errors[0].messages[0].message : null;
      if (field && error) {
        return { [field]: error };
      }
    }

    return null;
  };

  const onSubmit = async (values: Values) => {
    const complaint = parseInt(values.complaint!, 10);
    if (step === 2) {
      setComplaintId(complaint);
    }

    await refetch({ complaintId: complaint });
    increaseStep(step + 1);
  };
  return (
    <>
      {step !== 4
      && (
      <>
        <ComplaintHeader />
      </>
      )}
      {step < 3
    && (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, submitting, pristine }) => (
        <PickComplaint
          handleSubmit={handleSubmit}
          types={types}
          closeModal={closeModal}
          submitting={submitting}
          pristine={pristine}
          step={step}
          isMobile={isMobile}
        />
      )}
    />
    )}
      {step === 3
      && (
      <Form
        onSubmit={submitComplaint}
        render={({
          handleSubmit, submitting, pristine, hasValidationErrors,
        }) => (
          <SubmitComplaint
            handleSubmit={handleSubmit}
            closeModal={closeModal}
            submitting={submitting}
            pristine={pristine}
            isMobile={isMobile}
            error={hasValidationErrors}
            initialEmail={email}
          />
        )}
      />
      )}

      {step === 4
      && <SuccessfulComplain onClose={closeSuccessModal} />}
    </>
  );
};

export default ComplainForm;
